//关于我们页面
Vue.component(
    'about-index',
    resolve => require(["../../components/about"], resolve)
);

//加入我们页面
Vue.component(
    'about-recruit',
    resolve => require(["../../components/about/recruit"], resolve)
);



// WEBPACK FOOTER //
// ./resources/js/signCom/module/about.js